<ng-template custom-container-host  [currentComponent]="renderComponent"/>
